import { Component } from '@angular/core';

@Component({
  selector: 'app-reportes-index',
  templateUrl: './reportes-index.component.html',
  styleUrls: ['./reportes-index.component.scss']
})
export class ReportesIndexComponent {

}
